/* eslint-disable */
import _ from 'underscore';

function createGeneralsMiddleware() {
    return ({ dispatch, getState }) => {
        return (next) => {
            return (action) => {
                const state = getState();

                if (!_.isUndefined(action) && action.type && action.payload && action.payload.reducers) {
                    const typeAction = action.type.split('_');
                    if (action.type.indexOf('SUCCESS') == -1 && typeAction[0] == 'REQUEST') {
                        if (state[action.payload.reducers]) {
                            state[action.payload.reducers].isLoading = true;
                        }
                    }
                }


                next(action);
            };
        };
    };
}

const generalsMiddleware = createGeneralsMiddleware();

export default generalsMiddleware;
